export default {
	// api请求地址
	baseUrl: 'https://zgxffpgsg.com/',
	// 图片域名
	imgDomain: 'https://zgxffpgsg.com/',
	// 前端域名
	webDomain: 'https://zgxffpgsg.com/',
	// 腾讯地图key
	mpKey: 'GRSBZ-KXBED-CJW4Z-HFSHT-S2KUJ-34FNS'
}